/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import PaperSectionRuleVo from './PaperSectionRuleVo';




  /**
   * The PaperSectionVo model module.
   * @module course_standard/model/PaperSectionVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PaperSectionVo</code>.
   * @alias module:course_standard/model/PaperSectionVo
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>PaperSectionVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/PaperSectionVo} obj Optional instance to populate.
   * @return {module:course_standard/model/PaperSectionVo} The populated <code>PaperSectionVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'paperId')) {
        obj['paperId'] = ApiClient.convertToType(data['paperId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'directions')) {
        obj['directions'] = ApiClient.convertToType(data['directions'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'drillType')) {
        obj['drillType'] = ApiClient.convertToType(data['drillType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'subType')) {
        obj['subType'] = ApiClient.convertToType(data['subType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'quantity')) {
        obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'itemScore')) {
        obj['itemScore'] = ApiClient.convertToType(data['itemScore'], 'Number');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'ruleList')) {
        obj['ruleList'] = ApiClient.convertToType(data['ruleList'], [PaperSectionRuleVo]);
      }
    }
    return obj;
  }

  /**
   * paper section id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * paper id
   * @member {Integer} paperId
   */
  exports.prototype['paperId'] = undefined;
  /**
   * 排序
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 题目指令
   * @member {String} directions
   */
  exports.prototype['directions'] = undefined;
  /**
   * 题目类型
   * @member {Integer} drillType
   */
  exports.prototype['drillType'] = undefined;
  /**
   * 题目子类型
   * @member {Integer} subType
   */
  exports.prototype['subType'] = undefined;
  /**
   * 总题数
   * @member {Integer} quantity
   */
  exports.prototype['quantity'] = undefined;
  /**
   * 每题分值
   * @member {Number} itemScore
   */
  exports.prototype['itemScore'] = undefined;
  /**
   * 组卷规则
   * @member {Array.<module:course_standard/model/PaperSectionRuleVo>} ruleList
   */
  exports.prototype['ruleList'] = undefined;



  export default exports;
;


